import { z } from 'zod';

export class EnvironmentConfig {
  version: string;
  baseUrl: string;
  backendUrl: string;
  portalBackendUrl: string;
  production: boolean;
  build: { commit: string, number: string };
  logging: { serverLoggingEnabled: boolean, serverUrl: string, minLogLevel: string };
}

export function parseEnvironmentConfig(config: object): EnvironmentConfig {
  if ('configuration' in config) {
    config['production'] = config.configuration === 'production';
  }
  return RawEnvConfig.parse(config);
}

const RawEnvConfig = z.object({
  version: z.string(),
  baseUrl: z.string(),
  backendUrl: z.string(),
  portalBackendUrl: z.string(),
  production: z.boolean(),
  build: z.object({
    commit: z.string(),
    number: z.string(),
  }),
  logging: z.object({
    serverLoggingEnabled: z.boolean(),
    serverUrl: z.string(),
    minLogLevel: z.string(),
  }),
});
